import {AuthModel, UserModel} from './_models'
import {api, setToken, clearToken} from '../../../services/api'

export async function login(email: string, password: string): Promise<{data: AuthModel}> {
  const res = await api.adminLogin(email, password)
  setToken(res.accessToken)
  // The backend stores one `name`; this UI wants it split.
  const [firstName, ...rest] = (res.profile.name ?? '').trim().split(/\s+/)
  const user: UserModel = {
    id: 1,
    username: res.profile.email,
    password: undefined,
    email: res.profile.email,
    first_name: firstName ?? '',
    last_name: rest.join(' '),
    role: 'admin',
  }
  localStorage.setItem('admin_user', JSON.stringify(user))
  return {data: {api_token: res.accessToken}}
}

export async function getUserByToken(_token: string): Promise<{data: UserModel}> {
  const stored = localStorage.getItem('admin_user')
  if (stored) {
    return {data: JSON.parse(stored) as UserModel}
  }
  throw new Error('No user session found')
}

export function register(): Promise<void> {
  return Promise.reject(new Error('Registration is not available for the admin panel'))
}

export function requestPassword(email: string): Promise<{data: {result: boolean}}> {
  return Promise.resolve({data: {result: email.includes('@')}})
}

export function adminLogout() {
  clearToken()
  localStorage.removeItem('admin_user')
}
